import type { Mode } from '@/types'
import { getApiLink } from './utils/api-urls'
import { AXIOS_DEFAULT_OPTIONS } from './utils/consts'
import createApiClient from './utils/create-api-client'
import type { AxiosInstance } from 'axios'

// Error: [vitest] There was an error when mocking a module. If you are using "vi.mock" factory, make sure there are no top level variables inside, since this call is hoisted to top of the file. Read more: https://vitest.dev/api/vi.html#vi-mock
let appsApiClient: null | AxiosInstance = null

export function createAppsApi() {
    if (appsApiClient) {
        // eslint-disable-next-line no-console
        console.warn('apps api client already created')
        return
    }


    appsApiClient = createApiClient({
        ...AXIOS_DEFAULT_OPTIONS,
    })
}

export function updateAppsApi(mode: Mode) {
    if (appsApiClient) {
        appsApiClient.defaults.baseURL = getApiLink('apps', mode)
    }
}

export function useAppsApi() {
    if (appsApiClient) {
        return appsApiClient
    }

    throw new Error('apps api client hasn\'t been created')
}
